<nz-drawer #drawer2
  [nzVisible]="visible"
  [nzWidth]="400"
  [nzClosable]="false"
  (nzOnClose)="onClose()"
   nzPlacement="right"
  class="custom-drawer">
  <ng-container *nzDrawerContent>
        <div class="scroll-container" >
        <div nz-row>
            <div nz-col nzSpan="20">
                <div class="heading-fs-18 mb-0">{{isEditMode ? 'Edit Event' : 'Create Event'}}</div>
            </div>
            <div nz-col nzSpan="4" class="text-right pt-2">
                <span (click)="onClose()" nz-icon nzType="close" nzTheme="outline" class="cursor-pointer"></span>
            </div>
            <div nz-col nzSpan="24">
                <nz-divider></nz-divider>
            </div>
        </div>
        </div>
    <form [formGroup]="eventForm" class="event-drawer ">
      <div class="drawer-form-header">
        <div class="input-container">
          <nz-form-item>
            <nz-form-control>
              <nz-form-label [nzRequired]="true">Content Type</nz-form-label>
              <nz-select formControlName="contentType" 
                         nzPlaceHolder="Select content type" 
                         (ngModelChange)="onContentTypeChange($event)">
                <nz-option *ngFor="let contentType of contentTypeList" 
                           [nzValue]="contentType.id" 
                           [nzLabel]="contentType.name">
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        
        <div class="input-container">
          <nz-form-item>
            <nz-form-control>
              <nz-form-label [nzRequired]="true">Content</nz-form-label>
              
              <!-- Content selector for both media and playlist using drawer -->
              <div class="content-selector-container">
                <nz-input-group [nzSuffix]="suffixIconSearch">
                  <input nz-input 
                         [value]="getSelectedContentText()" 
                         [placeholder]="'Select ' + selectedContentType" 
                         readonly 
                         (click)="openContentDrawer()" />
                  <ng-template #suffixIconSearch>
                    <span (click)="openContentDrawer()"nz-icon nzType="plus" nzTheme="outline" class="content-selector-icon"></span>
                  </ng-template>
                </nz-input-group>
                <button nz-button nzType="primary" nzSize="small" 
                        class="mt-2" 
                        (click)="openContentDrawer()">
                  <span nz-icon nzType="plus"></span>
                  Select {{ selectedContentType | titlecase }}
                </button>
              </div>
              
              <div *ngIf="eventForm.get('content')?.invalid && eventForm.get('content')?.touched" class="validation-error-message">
                <span nz-icon nzType="exclamation-circle" nzTheme="fill" class="validation-icon mt-1"></span>
                <span class="ml-1">Content selection is required.</span>
              </div>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div class="input-container">
          <nz-form-item>
            <nz-form-control>
              <nz-form-label [nzRequired]="true">Event Name</nz-form-label>
              <nz-input-group>
                <input nz-input placeholder="Enter event name (e.g., Event - Dec 2, 3:15 PM)" formControlName="name" maxlength="100" autocomplete="off" (keydown.enter)="$event.preventDefault(); $event.stopPropagation(); onSave()" />
              </nz-input-group>
              <div *ngIf="eventForm.get('name')?.invalid && eventForm.get('name')?.touched" class="validation-error-message">
                <span nz-icon nzType="exclamation-circle" nzTheme="fill" class="validation-icon mt-1"></span>
                <span class="ml-1">Event name is required.</span>
              </div>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div class="input-container">
        <nz-form-item>
          <nz-form-control>
            <nz-form-label>Description</nz-form-label>
            <nz-input-group>
              <textarea nz-input placeholder="Enter event description (optional)" formControlName="description" rows="3" maxlength="500"></textarea>
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div class="input-container">
        <nz-form-item>
          <nz-form-control>
            <nz-form-label [nzRequired]="true">Start Date & Time</nz-form-label>
            <nz-date-picker formControlName="startDate" [nzAllowClear]="false" [nzShowTime]="timeOptions" nzFormat="yyyy-MM-dd hh:mm a" nzPlaceHolder="Select start date & time" style="width: 100%;"></nz-date-picker>
            <div *ngIf="eventForm.get('startDate')?.invalid && eventForm.get('startDate')?.touched" class="validation-error-message">
              <span nz-icon nzType="exclamation-circle" nzTheme="fill" class="validation-icon mt-1"></span>
              <span class="ml-1">Start date is required.</span>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div class="input-container">
        <nz-form-item>
          <nz-form-control>
            <nz-form-label [nzRequired]="true">End Date & Time</nz-form-label>
            <nz-date-picker formControlName="endDate" [nzAllowClear]="false" [nzShowTime]="timeOptions" nzFormat="yyyy-MM-dd hh:mm a" nzPlaceHolder="Select end date & time" style="width: 100%;"></nz-date-picker>
            <div *ngIf="eventForm.get('endDate')?.invalid && eventForm.get('endDate')?.touched" class="validation-error-message">
              <span nz-icon nzType="exclamation-circle" nzTheme="fill" class="validation-icon mt-1"></span>
              <span class="ml-1">End date is required.</span>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div class="input-container">
        <nz-form-item>
          <nz-form-control>
            <label nz-checkbox formControlName="allDay" (ngModelChange)="onAllDayToggle()">all-day</label>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div class="input-container">
        <nz-form-item>
          <nz-form-control>
            <nz-form-label>Priority</nz-form-label>
            <nz-select formControlName="priority" nzPlaceHolder="Select priority">
              <nz-option nzValue="low" nzLabel="Low"></nz-option>
              <nz-option nzValue="medium" nzLabel="Medium"></nz-option>
              <nz-option nzValue="high" nzLabel="High"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Recurrence Section -->
      <div class="input-container">
        <nz-form-item>
          <nz-form-control>
            <label nz-checkbox formControlName="isRecurring" (ngModelChange)="onRecurrenceToggle()">Repeat event</label>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div *ngIf="eventForm.get('isRecurring')?.value" class="recurrence-options">
        <div class="input-container">
          <nz-form-item>
            <nz-form-control>
              <nz-form-label>Repeat frequency</nz-form-label>
              <nz-select formControlName="recurrenceType" 
                         nzPlaceHolder="Select repeat frequency"
                         (ngModelChange)="onRecurrenceTypeChange()">
                <nz-option *ngFor="let option of getRecurrenceOptions(); trackBy: trackByRecurrence" 
                           [nzValue]="option.value" 
                           [nzLabel]="option.label">
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div *ngIf="eventForm.get('recurrenceType')?.value !== 'none'" class="input-container">
          <nz-form-item>
            <nz-form-control>
              <nz-form-label>Repeat every</nz-form-label>
              <nz-input-number formControlName="recurrenceInterval" [nzMin]="1" [nzMax]="99" style="width: 100%;"></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div *ngIf="eventForm.get('recurrenceType')?.value === 'weekly'" class="input-container">
          <nz-form-item>
            <nz-form-control>
              <nz-form-label>Repeat on</nz-form-label>
              <div class="weekly-days-selector">
                <label *ngFor="let day of getWeekDayOptions(); trackBy: trackByDay" 
                       nz-checkbox 
                       [nzChecked]="isWeekDaySelected(day.value)"
                       (nzCheckedChange)="toggleWeekDay(day.value)">
                  {{ day.label }}
                </label>
              </div>
            </nz-form-control>
          </nz-form-item>
        </div>

        <!-- Recurrence End Options -->
        <div *ngIf="eventForm.get('recurrenceType')?.value !== 'none'" class="input-container">
          <nz-form-item>
            <nz-form-control>
              <nz-form-label>Ends</nz-form-label>
              <nz-select formControlName="recurrenceEndType" 
                         nzPlaceHolder="Select when to end">
                <nz-option *ngFor="let option of getRecurrenceEndOptions(); trackBy: trackByEndType" 
                           [nzValue]="option.value" 
                           [nzLabel]="option.label">
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>

        <!-- After X occurrences -->
        <div *ngIf="eventForm.get('recurrenceEndType')?.value === 'count'" class="input-container">
          <nz-form-item>
            <nz-form-control>
              <nz-form-label>Number of occurrences</nz-form-label>
              <nz-input-number formControlName="recurrenceCount" [nzMin]="1" [nzMax]="999" style="width: 100%;" nzPlaceHolder="Enter number"></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </div>

        <!-- Ends on date -->
        <div *ngIf="eventForm.get('recurrenceEndType')?.value === 'until'" class="input-container">
          <nz-form-item>
            <nz-form-control>
              <nz-form-label>End date</nz-form-label>
              <nz-date-picker formControlName="repeatEndDate" 
                              nzPlaceHolder="Select end date"
                              [nzShowTime]="false"
                              [nzAllowClear]="false"
                              nzFormat="yyyy-MM-dd"
                              style="width: 100%;">
              </nz-date-picker>
              <div *ngIf="eventForm.get('repeatEndDate')?.invalid && eventForm.get('repeatEndDate')?.touched" class="validation-error-message">
                <span nz-icon nzType="exclamation-circle" nzTheme="fill" class="validation-icon mt-1"></span>
                <span class="ml-1">End date is required.</span>
              </div>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="drawer-actions">
        <button nz-button nzType="default" (click)="onClose()">Cancel</button>
        <button nz-button nzType="primary" (click)="onSave()" 
                [disabled]="eventForm.invalid || isSaving" 
                [nzLoading]="isSaving">
          {{ isEditMode ? 'Update' : 'Create' }}
        </button>
      </div>
    </form>
  </ng-container>
</nz-drawer>

<!-- Content Selection Drawer -->
<nz-drawer #drawer
           [nzClosable]="false"
           [nzVisible]="showMedias"
           nzPlacement="right"
           [nzMaskClosable]="true"
           [nzZIndex]="1050"
           (nzOnClose)="closeMediaDrawer(null)"
           class="custom-drawer">
  <ng-container *nzDrawerContent>
    <!-- Media Selection (Single Selection) -->
    <app-media-list-multi-select 
      (closeDrawer)="closeMediaDrawer($event)" 
      *ngIf="showMedias && selectedContentType === 'media'"
      [selectedMediaList]="selectedMedia" 
      [selectedMediaIds]="selectedMediaIds"
      [singleSelection]="true"
      [labelText]="'Send to Schedule'"
      [groupId]="getCurrentGroupId()">
    </app-media-list-multi-select>
    
    <!-- Playlist Selection (Single Selection enforced in handler) -->
    <app-display-list-multi-select 
      (closeDrawer)="closePlaylistDrawer($event)" 
      *ngIf="showMedias && selectedContentType === 'playlist'"
      [selectedPlaylists]="selectedPlaylists" 
      [selectedPlaylistIds]="selectedPlaylistIds"
      [selectedGroupId]="getCurrentGroupId()"
      [singleSelection]="true"
      [labelText]="'Send to Schedule'">
    </app-display-list-multi-select>
  </ng-container>
</nz-drawer>